module.exports = __webpack_public_path__ + "static/media/photo-6.c2d4eb93.jpg";